// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"ee733596","453":"d855a71b","491":"b17ff98e","695":"975f2839","736":"0348481c","840":"d2744b61"}[chunkId] + ".chunk.js";
};